import { Routes } from '@angular/router';
import { Login } from './pages/login/login';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: Login,
    canActivate: [guestGuard]
  },

  {
    path: 'auth/reset-password',
    loadComponent: () => import('./pages/auth/reset-password/reset-password').then(m => m.ResetPasswordComponent),
  },

  {
    path: 'cadastro-cliente/:token',
    loadComponent: () => import('./pages/auth/client-registration/client-registration').then(m => m.ClientRegistrationComponent),
  },

  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () => import('./layout/layout.routes').then((r) => r.LAYOUT_ROUTES),
  },
];
